import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";


import useSelectedProduct from "../../componentHooks/useSelectedProduct";
import useCategoryToProductsList from "../../apiHooks/useCategoryToProductsList";
import { API_STATUS } from "../../constants/app.constants";


import Loader from "../loader/loader";
import ProductsList from "../products-list/products-list.component";
import ErrorCard from "../error-card/error-card.component";
import ApisListContainer from "../apis-list-container/apis-list-container.component";
import SearchBar from "../search-bar/search-bar.component";
import IotApiKeyCard from "../iot-api-key-card/iot-api-key-card.component";
import PrivateComponent from "../../common/private-component/private-component.component";

import "./products-container.component.scss";


const { LOADING, SUCCESS, ERROR } = API_STATUS;

const ProductsContainer = () => {
  const history = useHistory();
  const { status, fetchCategoryToProductsList } = useCategoryToProductsList();
  const { selectedProduct } = useSelectedProduct();
  
  const [searchValue, setSearchValue] = useState(null);

  useEffect(() => {
    fetchCategoryToProductsList();
  }, []);

  const onChangeSearchValue = (value) => {
    setSearchValue(value);
  };

  const renderScenarios = {
    [LOADING]: <Loader />,
    [SUCCESS]: <ProductsList />,
    [ERROR]: <ErrorCard />,
  };

  if (status === LOADING) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <PrivateComponent >
      <div className="products_container">
        <div>
          <main className="mx-auto px-4 sm:px-6 lg:px-8">

            <div className="flex items-baseline justify-between pt-8">
              <h1 className="py-6 text-4xl font-semibold">APIs</h1>
              <SearchBar
                searchValue={searchValue}
                onChange={(value) => onChangeSearchValue(value)}
              />
            </div>


            <section aria-labelledby="products-heading" className="pb-16 pt-6">

              <IotApiKeyCard />
              <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                {renderScenarios[status]}

                <div className="lg:col-span-3">
                  <ApisListContainer searchValue={searchValue} />
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </PrivateComponent>

  );
};

export default ProductsContainer;
